import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Our Story", hash: "#story" },
  { label: "Menu", hash: "#menu" },
  { label: "Events", hash: "#events" },
];

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Header() {
  const [open, setOpen] = useState(false);

  const go = (e, hash) => {
    e.preventDefault();
    setOpen(false);
    scrollToHash(hash);
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b-[3px] border-ink bg-cream/95 backdrop-blur"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <a href="/" className="group" data-testid="header-logo-link" onClick={(e) => go(e, "#top")}>
          <Logo />
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={l.hash}
              onClick={(e) => go(e, l.hash)}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              className="text-sm font-extrabold uppercase tracking-wider text-ink transition-colors duration-200 hover:text-tang"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#book"
            onClick={(e) => go(e, "#book")}
            data-testid="header-book-now-btn"
            className="hidden items-center gap-1.5 rounded-full border-[3px] border-ink bg-tang px-5 py-2.5 text-sm font-extrabold uppercase tracking-wide text-white shadow-pop transition-all duration-200 hover:-translate-y-0.5 hover:bg-tang-dark hover:shadow-popLg sm:inline-flex"
          >
            Book Now <ArrowRight className="h-4 w-4" strokeWidth={3} />
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-xl border-[3px] border-ink bg-white shadow-pop transition-transform duration-200 active:translate-y-0.5 md:hidden"
          >
            {open ? <X className="h-5 w-5" strokeWidth={3} /> : <Menu className="h-5 w-5" strokeWidth={3} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="border-t-[3px] border-ink bg-cream px-4 py-4 md:hidden"
        >
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.hash}
                href={l.hash}
                onClick={(e) => go(e, l.hash)}
                className="rounded-lg px-3 py-2.5 text-base font-extrabold uppercase tracking-wide text-ink transition-colors duration-200 hover:bg-sunburst/40"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={(e) => go(e, "#book")}
              data-testid="mobile-book-now-btn"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full border-[3px] border-ink bg-tang px-5 py-3 text-sm font-extrabold uppercase tracking-wide text-white shadow-pop"
            >
              Book Now <ArrowRight className="h-4 w-4" strokeWidth={3} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
